import {
  ClickedLocation,
  useClickedSupplierAccordionAnalytics,
} from '@bridebook/web/app-basic/lib/analytics/hooks/use-clicked-supplier-accordion-analytics';
import {
  getPremium,
  getQuestions,
  getSpecialOffers,
  getSupplier,
} from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import FaqComp from '@bridebook/web/app-basic/components/supplier/sections/faq/faq';

const Faq = () => {
  const supplier = useSelector(getSupplier);
  const premium = useSelector(getPremium);
  const offers = useSelector(getSpecialOffers);
  const questions = useSelector(getQuestions);
  const clickedAccordionAnalytics = useClickedSupplierAccordionAnalytics(ClickedLocation.Faq);

  if (!questions || !supplier) return null;

  return (
    <FaqComp
      onToggleAccordion={clickedAccordionAnalytics}
      supplier={supplier}
      premium={premium}
      offers={offers}
      questions={questions}
    />
  );
};

export default Faq;
